import type { Object3D } from "three"

let tempLayer : number
function inner (obj : Object3D): void {
  obj.layers.set(tempLayer)
}

export default function setLayerRecursively (obj : Object3D, layer : number): void {
  tempLayer = layer
  obj.traverse(inner)
}
